// src/pages/B2B/ProductInfo/ProductUniquePageB2B.jsx
import React from "react";
import {
  Box,
  Container,
  Typography,
  Breadcrumbs,
  Link as MLink,
  Grid,
} from "@mui/material";
import { useLocation, useNavigate, Link as RouterLink } from "react-router-dom";

export default function ProductUniquePageB2B() {
  const location = useLocation();
  const navigate = useNavigate();

  const state = location.state || {};

  const title = state.title || "產品特色介紹";
  const image = state.image || "/img/placeholder.png";
  const image2 = state.image2;
  console.log(image);
  const paragraphs = Array.isArray(state.paragraphs)
    ? state.paragraphs
    : state.text
    ? [state.text]
    : ["請從商品資訊頁面點選指定商品進入此頁面，以顯示對應的產品說明內容。"];

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#fffffc", py: { xs: 3, md: 4 } }}>
      <Container maxWidth="lg">
        {/* Breadcrumbs */}
        <Breadcrumbs sx={{ mb: 2 }}>
          <MLink
            component={RouterLink}
            underline="hover"
            color="inherit"
            to="/b2b/"
          >
            首頁
          </MLink>
          <MLink
            component={RouterLink}
            underline="hover"
            color="inherit"
            to="/b2b/商品資訊"
          >
            商品資訊
          </MLink>
          <Typography color="text.primary">{title}</Typography>
        </Breadcrumbs>

        {/* Title */}
        <Box
          sx={{
            mb: { xs: 3, md: 4 },
            px: { xs: 2, md: 4 },
            py: { xs: 2, md: 3 },
            borderRadius: 2,
            bgcolor: "#f7f8f3",
            textAlign: "center",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: "#42b649",
              fontFamily: "LINE Sans TW, Noto Sans TC, system-ui",
            }}
          >
            {title}
          </Typography>
        </Box>

        {/* Image + Text block */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            gap: { xs: 2.5, md: 4 },
          }}
        >
          {/* Image: left on desktop, top on mobile */}
          <Box sx={{ mb: { xs: 3, md: 4 } }}>
            <Box
              component="img"
              src={image}
              alt={title}
              sx={{
                display: "block",
                width: "100%",
                height: "auto",
                objectFit: "cover",
              }}
            />
          </Box>

          {/* Text: right on desktop, below on mobile */}
          <Box
            sx={{
              px: { xs: 2, md: 7 },
              py: { xs: 2, md: 3 },
              maxHeight: { md: "100%" },
              overflowY: { md: "auto" },
              alignContent: "center",
            }}
          >
            {paragraphs.map((line, idx) => (
              <Typography
                key={idx}
                paragraph
                sx={{
                  fontFamily: "LINE Sans TW",
                  fontSize: { xs: 15, md: 18 },
                  lineHeight: 2,
                  color: "text.primary",
                  mb: { xs: 0.75, md: 1.25 },
                }}
              >
                {line}
              </Typography>
            ))}
          </Box>
        </Box>
        {image2 && (
          <Box
            component="img"
            src={image2}
            alt={title}
            sx={{
              display: "block",
              width: "100%",
              height: "auto",
              objectFit: "cover",
            }}
          />
        )}
      </Container>
    </Box>
  );
}
